import React, { useState } from "react";
import { ButtonGroup, Button, Menu, MenuItem, IconButton } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';

export default function UserMenuResponsive({ senhaDestaque, setOpenModal, handleLogout }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const onClickSenha = () => {
    setOpenModal(true);
    handleMenuClose();
  };

  const onClickSair = () => {
    handleLogout();
    handleMenuClose();
  };

  return (
    <>
      {/* Desktop: botões visíveis, escondidos no mobile */}
      <ButtonGroup
        disableElevation
        variant="contained"
        aria-label="grupo botões senha e sair"
        sx={{
          display: { xs: 'none', sm: 'inline-flex' }, // escondido xs (mobile), mostra sm+
        }}
      >
        <Button
          variant={senhaDestaque ? 'contained' : 'outlined'}
          color="inherit"
          className={senhaDestaque ? 'botaoDestaque' : ''}
          startIcon={<LockIcon />}
          onClick={() => setOpenModal(true)}
        >
          Senha
        </Button>
        <Button
          color="error"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
        >
          Sair
        </Button>
      </ButtonGroup>

      {/* Mobile: ícone hamburger visível somente no xs */}
      <IconButton
        aria-label="menu de usuário"
        aria-controls={menuOpen ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleMenuClick}
        sx={{ display: { xs: 'inline-flex', sm: 'none' } }}
        size="large"
      >
        <MenuIcon />
      </IconButton>

      {/* Menu dropdown */}
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={onClickSenha} >
          <LockIcon fontSize="small" sx={{ mr: 1 }} />
          Senha
        </MenuItem>
        <MenuItem onClick={onClickSair}>
          <LogoutIcon fontSize="small" sx={{ mr: 1, color: 'error.main' }} />
          Sair
        </MenuItem>
      </Menu>
    </>
  );
}
